import { render, staticRenderFns } from "./RecurringSMSCampaignCreateRoute.vue?vue&type=template&id=2def1a15&scoped=true&"
import script from "./RecurringSMSCampaignCreateRoute.vue?vue&type=script&lang=js&"
export * from "./RecurringSMSCampaignCreateRoute.vue?vue&type=script&lang=js&"
import style0 from "./RecurringSMSCampaignCreateRoute.vue?vue&type=style&index=0&id=2def1a15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2def1a15",
  null
  
)

export default component.exports